/* Drop: minimal streetwear theme */
(function () {
  'use strict';

  var root = document.documentElement;
  var routes = window.themeRoutes || { cartAdd: '/cart/add.js', cart: '/cart.js' };

  /* ---------- Light / dark toggle ---------- */

  var toggles = document.querySelectorAll('[data-theme-toggle]');
  var themeMeta = document.querySelector('meta[name="theme-color"]');

  function applyTheme(mode, persist) {
    root.setAttribute('data-theme', mode);
    if (themeMeta) {
      themeMeta.setAttribute('content', mode === 'light' ? themeMeta.dataset.light : themeMeta.dataset.dark);
    }
    toggles.forEach(function (t) {
      t.setAttribute('aria-label', mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
    });
    if (persist) {
      try { localStorage.setItem('drop-theme', mode); } catch (e) {}
    }
  }

  applyTheme(root.getAttribute('data-theme') === 'light' ? 'light' : 'dark', false);

  toggles.forEach(function (t) {
    t.addEventListener('click', function () {
      applyTheme(root.getAttribute('data-theme') === 'light' ? 'dark' : 'light', true);
    });
  });

  /* ---------- Policies dropdown ---------- */

  var policies = document.querySelector('[data-policies]');
  if (policies) {
    document.addEventListener('click', function (e) {
      if (!policies.contains(e.target)) policies.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') policies.removeAttribute('open');
    });
  }

  /* ---------- Toast + cart count ---------- */

  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;

  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function refreshCount() {
    return fetch(routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); });
  }

  /* ---------- Add to cart (no page reload) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-quick-add]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add that');
        toast('Added to cart');
        return refreshCount();
      })
      .catch(function (err) { toast(err.message || 'Something went wrong'); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ---------- Product feed: pop-up reveal on swipe ---------- */

  var feed = document.querySelector('[data-feed]');
  if (feed) {
    var slides = feed.querySelectorAll('[data-slide]');

    if (!('IntersectionObserver' in window)) {
      slides.forEach(function (s) { s.classList.add('is-active'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-active', entry.isIntersecting);
        });
      }, { root: feed, threshold: 0.55 });
      slides.forEach(function (s) { io.observe(s); });
    }

    feed.addEventListener('scroll', function () {
      feed.classList.add('is-scrolled');
    }, { once: true, passive: true });
  }

  /* ---------- Photo galleries: arrows + counter ---------- */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-track]');
    if (!track) return;

    var prev = gallery.querySelector('[data-prev]');
    var next = gallery.querySelector('[data-next]');
    var counter = gallery.querySelector('[data-counter]');
    var count = track.children.length;
    var frame = null;

    function current() {
      return Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
    }

    function goTo(i) {
      track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    if (counter) {
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          counter.textContent = (current() + 1) + ' / ' + count;
        });
      }, { passive: true });
    }

    /* On the product page the left/right keys flip through photos */
    if (gallery.closest('[data-product]')) {
      document.addEventListener('keydown', function (e) {
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
        if (e.key === 'ArrowLeft' && prev) prev.click();
        if (e.key === 'ArrowRight' && next) next.click();
      });
    }
  });

  /* ---------- Product page: variant picker ---------- */

  var product = document.querySelector('[data-product]');
  if (product) {
    var dataEl = product.querySelector('[data-variants]');
    var idInput = product.querySelector('input[name="id"]');
    var addBtn = product.querySelector('[data-add]');
    var groups = product.querySelectorAll('[data-option-group]');

    if (dataEl && idInput && addBtn && groups.length) {
      var variants = JSON.parse(dataEl.textContent);

      var updateVariant = function () {
        var picked = Array.prototype.map.call(groups, function (g) {
          var checked = g.querySelector('input:checked');
          return checked ? checked.value : null;
        });

        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === picked[i]; });
        });

        product.querySelectorAll('[data-price-variant]').forEach(function (el) {
          el.hidden = !match || String(match.id) !== el.getAttribute('data-price-variant');
        });

        if (!match) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          return;
        }

        idInput.value = match.id;
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';

        try { history.replaceState(null, '', location.pathname + '?variant=' + match.id); } catch (e) {}

        if (match.featured_image) {
          var img = product.querySelector('[data-image-id="' + match.featured_image.id + '"]');
          if (img && img.scrollIntoView) {
            img.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        }
      };

      groups.forEach(function (g) { g.addEventListener('change', updateVariant); });
    }
  }

  /* ---------- Cart page: auto-update quantities ---------- */

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.form) input.form.submit();
    });
  });
})();
